import { c as _c } from "react/compiler-runtime";
import useProductLocalStock from 'data-hooks/useProductLocalStock';

// Get stock data for this product
const usePDPLocalStock = (t0, t1) => {
  const $ = _c(5);
  const {
    id,
    slug,
    productOptions
  } = t0;
  const {
    skip: skipAll
  } = t1;
  let t2;
  if ($[0] !== id || $[1] !== productOptions || $[2] !== skipAll || $[3] !== slug) {
    t2 = {
      slug,
      id,
      options: productOptions,
      skipAll
    };
    $[0] = id;
    $[1] = productOptions;
    $[2] = skipAll;
    $[3] = slug;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const stock = useProductLocalStock(t2);
  return stock;
};
export default usePDPLocalStock;